module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Half-star-cb8409fadfc03586744ceba80afed8bd.svg";